import React from 'react'
import { Table, Input, Button, Popconfirm } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import styled from 'styled-components'

const InputGroup = styled.div`
  display: flex;
  align-items: center;
  .discount-input {
    width: 60px;
    padding-left: 2px;
    padding-right: 2px;
    text-align: center;
  }
`

const CustomerBillTable = (props) => {
  const { onChange, onDelete } = props
  const tableColumns = [
    {
      title: '',
      dataIndex: '',
      key: 'x',
      width: '50px',
      fixed: 'left',
      render: (_, record) => {
        return (
          <Popconfirm
            title="คุณต้องการลบรายการนี้ใช่ไหม ?"
            okText="ลบ"
            cancelText="ยกเลิก"
            onConfirm={() => onDelete(record)}
          >
            <Button
              size="small"
              type="primary"
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        )
      },
    },
    {
      title: 'รหัส',
      dataIndex: 'code',
      key: 'code',
      width: '70px',
      fixed: 'left',
    },
    {
      title: 'Vat',
      dataIndex: 'product_vat_type_name',
      key: 'product_vat_type_name',
      width: '50px',
      fixed: 'left',
      render: (text) => (
        <div className={text === 'IV' ? 'iv-text' : ''}>{text}</div>
      ),
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'name',
      key: 'name',
      width: '400px',
      fixed: 'left',
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '80px',
      // render: (_, record) => {
      //   return (
      //     <Input
      //       className="text-align-right"
      //       value={record.quantity}
      //       onChange={(event) =>
      //         onChange(record, 'quantity', event.target.value)
      //       }
      //     />
      //   )
      // },
    },
    {
      title: 'หน่วย',
      dataIndex: 'unit_name',
      key: 'unit_name',
      width: '80px',
    },
    {
      title: 'ราคาต่อหน่วย',
      dataIndex: 'price_out',
      key: 'price_out',
      width: '130px',
      className: 'text-align-right',
      render: (_, record) => {
        return (
          <Input
            className="text-align-right"
            value={record.price_out}
            size="small"
            onChange={(event) =>
              onChange(record, 'price_out', event.target.value)
            }
          />
        )
      },
    },
    {
      title: 'ส่วนลด',
      dataIndex: '',
      key: 'v',
      width: '300px',
      render: (_, record) => {
        return (
          <InputGroup>
            <Input
              className="discount-input"
              value={record.discount_1}
              size="small"
              onChange={(event) =>
                onChange(record, 'discount_1', event.target.value)
              }
            />
            +
            <Input
              className="discount-input"
              value={record.discount_2}
              size="small"
              onChange={(event) =>
                onChange(record, 'discount_2', event.target.value)
              }
            />
            +
            <Input
              className="discount-input"
              value={record.discount_3}
              size="small"
              onChange={(event) =>
                onChange(record, 'discount_3', event.target.value)
              }
            />
            +
            <Input
              className="discount-input"
              value={record.discount_4}
              size="small"
              onChange={(event) =>
                onChange(record, 'discount_4', event.target.value)
              }
            />
          </InputGroup>
        )
      },
    },
    {
      title: 'ยอดรวม',
      dataIndex: 'total',
      key: 'total',
      width: '110px',
      render: (text) => <div className="text-align-right">{text}</div>,
    },
    {
      title: 'หมายเหตุ',
      dataIndex: 'remark',
      key: 'remark',
      width: '200px',
      render: (_, record) => {
        return (
          <Input
            value={record.remark}
            size="small"
            onChange={(event) => onChange(record, 'remark', event.target.value)}
          />
        )
      },
    },
  ]

  return (
    <div>
      <Table
        rowKey={(record) => `id+${record.product_code}`}
        dataSource={props.productList}
        columns={tableColumns}
        pagination={false}
        scroll={{ x: 1500 }}
        style={{ minHeight: '340px', backgroundColor: '#FFFFFF' }}
        size="small"
      />
    </div>
  )
}

export default CustomerBillTable
